export default __webpack_public_path__ + "static/media/logo-v2-yellow.33f62c7e.svg";